"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _TagStyled = require("./TagStyled");
var Theme = _interopRequireWildcard(require("./TagTheme"));
/**
 * A Tag labels UI objects for quick recognition and navigation.
 */
const Tag = _ref => {
  let {
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy,
    children,
    className,
    color = "blue",
    clientId
  } = _ref;
  let backgroundColor, textColor;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  if (typeof color === "string") {
    backgroundColor = Theme.backgroundColor(color, themeMode);
    textColor = (0, _designTokensReact.color)("color--text--neutral--strong");
  } else {
    ({
      backgroundColor,
      textColor
    } = color);
  }
  return /*#__PURE__*/_react.default.createElement(_TagStyled.TagStyled, {
    className: className,
    backgroundColor: backgroundColor,
    textColor: textColor,
    "data-client-id": clientId,
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedBy
  }, children);
};
exports.Tag = Tag;
//# sourceMappingURL=Tag.js.map